import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=33fbcda4&scoped=true&"
import script from "./service-detail.vue?vue&type=script&lang=js&"
export * from "./service-detail.vue?vue&type=script&lang=js&"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=33fbcda4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbcda4",
  null
  
)

component.options.__file = "service-detail.vue"
export default component.exports